import Landing from 'src/containers/Landing/Landing';

export default Landing;